import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';
import * as React from 'react';

const ELTextIcon: React.FC<SvgIconProps> = props => {
	return (
		<SvgIcon {...props}>
			<g fillRule="evenodd">
				<path d="m5.0374 6.0876c-0.67821 0.13621-1.3893 0.3154-2.1625 0.54098v14.305c1.6549-0.31494 3.3358-0.4958 5.1006-0.56612 1.2296-0.04899 3.9438 0.433 3.9438 0.433 0.14312 0.3182 1.5202 0.25186 1.5202 0.25186l1e-3 -1.1978s-1.3661 0.0696-1.3251-0.4134c0 0-1.9887-0.39082-3.4363-0.39088-1.5404-7e-5 -2.8144 0.07691-4.3109 0.30658l-0.010579-12.363z" />
				<path d="m21.844 6.0876c0.6782 0.13621 1.3893 0.3154 2.1625 0.54098v14.305c-1.6549-0.31494-3.3358-0.4958-5.1006-0.56612-1.2296-0.04899-3.9438 0.433-3.9438 0.433-0.14312 0.3182-1.5202 0.25186-1.5202 0.25186l-1e-3 -1.1978s1.3661 0.0696 1.3251-0.4134c0 0 1.9887-0.39082 3.4363-0.39088 1.5404-7e-5 2.8144 0.07691 4.3109 0.30658l0.01058-12.363z" />
				<path d="m9.2275 5.0998c-1.0717-0.0016418-2.1114 0.23823-3.4113 0.72014l-0.065372 11.245c2.1135-0.31046 3.3353-0.47197 5.4738-0.08649 0.70243 0.16468 1.3093 0.57585 1.6156 0.89879v-12.059c-1.4345-0.47499-2.542-0.71749-3.6128-0.71914z" />
			</g>
			<g
				fill="none"
				stroke="#fff"
				strokeLinecap="round"
				strokeWidth=".52916"
			>
				<path d="m7.276 7.3748h4.0135" />
				<path d="m7.276 14.552h4.0135" />
				<path d="m7.276 12.159h4.0135" />
				<path d="m7.276 9.7671h4.0135" />
				<path d="m19.524 7.176h-4.0135" />
				<path d="m19.524 13.526h-4.0135" />
				<path d="m19.524 11.409h-4.0135" />
				<path d="m19.524 9.2927h-4.0135" />
			</g>
			<path
				d="m17.56 5.0999c1.0717-0.00164 2.1114 0.23823 3.4113 0.72014l0.06537 11.245c-2.1135-0.31046-3.3353-0.47197-5.4738-0.08649-0.70243 0.16468-1.3093 0.57585-1.6156 0.89879v-12.059c1.4345-0.47499 2.542-0.71749 3.6128-0.71914z"
				fillRule="evenodd"
			/>
			<g
				fill="none"
				stroke="#fff"
				strokeLinecap="round"
				strokeWidth=".52916"
			>
				<path d="m19.512 7.3748h-4.0135" />
				<path d="m19.512 14.552h-4.0135" />
				<path d="m19.512 12.159h-4.0135" />
				<path d="m19.512 9.7671h-4.0135" />
			</g>
		</SvgIcon>
	);
};

export default ELTextIcon;



// WEBPACK FOOTER //
// ./src/icons/ELTextIcon.tsx